import React from "react";
import theme from "@/foundation/Theme";
import { Heading, HeadingWrapper } from "./style";

function HeadingComponent({
  title = "",
  m = "",
  wrapperPadding = "0 0 16px 0",
  variant = "heading5",
  color = theme.colorsV2.gray.shade_800,
  borderColor = theme.colorsV2.shyft.purple_text,
  borderWidth = "2px",
}) {
  return (
    <HeadingWrapper
      p={wrapperPadding}
      m={m}
      borderBottomColor={borderColor}
      borderBottomWidth={borderWidth}
    >
      <Heading variant={variant} color={color}>
        {title}
      </Heading>
    </HeadingWrapper>
  );
}

export default HeadingComponent;
